import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const FarmerTotalHarvestDynamicReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonData, setSeasondata] = useState([]);
  const [ranchData, setRanchdata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [seasonId, setSeasonId] = useState();
  const [ranchId, setRanchId] = useState();
  const [cropId, setCropId] = useState("");
  const [cropFilterList, setCropFilterList] = useState([]);
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRanchWeighBridgeFarmerData } = useHttp();
  const fillRanchWeighBridgeFarmerData = () => {
    let urlfilter = "";

    if (seasonId && seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }
    if (ranchId && ranchId > 0) urlfilter += `&ranchId=${ranchId}`;
    if (showDateFilter) urlfilter += `&fromDate=${selectedFromDate}&toDate=${selectedToDate}`;
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNumber) urlfilter += `&farmerNo=${farmerNumber}`;
    if (fieldName) urlfilter += `&fieldId=${fieldName}`;

    const url = `/api/farmerTotalHarvestReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getRanchWeighBridgeFarmerData({ url }, (data) => {
      setData(data);  // ✔ Harvest only
    });
  };


  // const { sendRequest: getprocurementData } = useHttp();
  // const fillprocurementData = (e) => {
  //   if (e) e.preventDefault();
  //   let urlfilter = "";

  //   if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
  //   if (seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
  //   if (ranchId > 0) urlfilter += `&ranchId=${ranchId}`;
  //   if (farmerNumber) urlfilter += `&farmerNo=${farmerNumber}`;

  //   const url = `/api/farmerScoreboardReport/?orgId=${localStorage.getItem(
  //     "orgId"
  //   )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

  //   getprocurementData({ url }, (data) => {
  //     setData(data);
  //   });
  // };

  useEffect(() => {
    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    var urlfilter = `&ranchId=${ranchId}`;

    getRanchWeighBridgeFarmerData(
      {
        url: `/api/farmerTotalHarvestReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
      },
      (res) => {
        const reportData = res || [];

        const uniqueFields = [
          ...new Set(
            reportData
              .map((item) => item.fieldName)
              .filter(Boolean)
          ),
        ];

        const fieldList = uniqueFields.map((f) => ({
          fieldCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );
  }, [ranchId]);

  useEffect(() => {
    fillRanchWeighBridgeFarmerData();
  }, [
    seasonId,
    employeeId,
    ranchId,
    fieldName,
    farmerNumber,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
    cropId,
  ]);

  // Define a map for custom header display names
  const headerNameMapping = {
    farmerNo: "Farmer No",
    farmerName: "Farmer Name",
    Field: "Field",
    FieldSize: "Field Size",
    Crop: "Crop",
    FieldCategory: "Field Category",
    ExecutiveName: "Executive Name",
    TotalYield: "Total Yield",
    "Yield/Ha": "Yield/Ha",
    "Number of crate per farmer": "No of Crates/Farmer",
    Unit: "Unit",
  };

  // Converts camelCase or snake_case keys to spaced Title Case if no mapping found
  const toTitleCaseWithSpace = (str) => {
    if (!str) return "";
    const spaced = str
      // Replace underscores or camelCase boundaries with space
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ");
    return spaced
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const exportToExcel = (data, fileName = "FarmerTotalHarvestReport") => {
    if (!Array.isArray(data) || data.length === 0) {
      alert("No data to export");
      return;
    }

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export the workbook to a file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const handleExport = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    exportToExcel(data, "FarmerTotalHarvestReport");
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("Crop API Full Response:", res);
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);

  const { sendRequest: getRanchData } = useHttp();
  useEffect(() => {
    getRanchData(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchdata(data);
      }
    );
  }, [getRanchData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/harvestFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData?.map((item) => ({ value: item.farmerNo })) || [];

  const excelDownload = async (employeeId, farmerNo, getType = "") => {
    setLoading(true);

    var urlfilter = "";
    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
    if (farmerNo != "") urlfilter += `&farmerNo=${farmerNo}`;
    if (getType != "") urlfilter += `&getType=${getType}`;


    var url = `${process.env.REACT_APP_BASE_URL
      }/api/RanchWeighbridgeFarmerReport/?orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "farmerEnrollmentReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  // const headerNameMapping = {
  //   "Number of crate per farmer": "No of Crates/Farmer",
  // };

  function toCamelCaseWithSpace(str) {
    if (!str) return "";
    return str
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">
              Farmer Harvest Details
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    id="cropNameId"
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>

                    {cropFilterList &&
                      cropFilterList.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* Season Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      setSeasonId(e.target.value || 0);
                      EmployeeDetail(e.target.value || 0);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Ranch Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch Name</label>
                  <select
                    id="RanchId"
                    className="form-control"
                    ref={(el) => (frmRef.current["RanchId"] = el)}
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value);
                      setFieldName("");
                      EmployeeDetail(e.target.value);
                      setEmployeeId(0);

                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Procurement Officer */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}



              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                  onSelect={(value) => {
                    setFarmerNumber(value);
                    fillRanchWeighBridgeFarmerData();
                  }}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={() => {
                      fillRanchWeighBridgeFarmerData();
                    }}
                  >
                    Submit
                  </button>

                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-success mx-2"
                onClick={handleExport}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          {currentItems &&
                            currentItems.length > 0 &&
                            Object.keys(currentItems[0])
                              .filter(
                                (key) => key !== "farmerId" && key !== "FieldId"
                              )
                              .map((key, i) => {
                                const displayName =
                                  headerNameMapping[key] ||
                                  toCamelCaseWithSpace(key);
                                return <th key={i}>{displayName}</th>;
                              })}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((item, rowIndex) => (
                            <tr key={rowIndex} className="tablerowview">
                              {Object.keys(item)
                                .filter(
                                  (key) =>
                                    key !== "farmerId" && key !== "FieldId"
                                )
                                .map((key, colIndex) => (
                                  <td key={colIndex}>
                                    {
                                      typeof item[key] === "object"
                                        ? JSON.stringify(item[key])
                                        : typeof item[key] === "number"
                                          ? item[key].toLocaleString()
                                          : item[key]
                                    }
                                  </td>

                                ))}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerTotalHarvestDynamicReport;
